import { render } from "./ProfileHeader.vue?vue&type=template&id=9384c72c&ts=true"
import script from "./ProfileHeader.vue?vue&type=script&lang=ts"
export * from "./ProfileHeader.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__